export interface SummaryBarProps {
  itemCount: number;
  selectedProductName: string | null;
  /**
   * Optional cart-open handler. When provided, a "View list" button is rendered
   * inside the bar — clicking it opens the cart modal. Wired by the parent tool
   * only when `layout.showCart` is on; absent here = no button.
   */
  onOpenCart?: () => void;
}

/**
 * Bottom-right floating summary card. Shows item count + currently-selected
 * product name. When the cart feature is enabled, also renders a "View list"
 * button that opens the cart modal (the bar itself stays informational).
 */
export function SummaryBar({ itemCount, selectedProductName, onOpenCart }: SummaryBarProps) {
  const cartDisabled = itemCount === 0;
  return (
    <div className="sd-summary">
      <div className="sd-summary__count">
        <span className="sd-summary__count-value">{itemCount}</span>
        <span className="sd-summary__count-label">{itemCount === 1 ? "item" : "items"}</span>
      </div>
      {selectedProductName && (
        <div className="sd-summary__selected" title={selectedProductName}>
          {selectedProductName}
        </div>
      )}
      {onOpenCart && (
        <button
          type="button"
          className="sd-summary__cart-btn"
          onClick={onOpenCart}
          disabled={cartDisabled}
          title={cartDisabled ? "Place a product to see the list" : "View element list"}
        >
          View list
        </button>
      )}
    </div>
  );
}
